import { Map } from 'immutable';

import * as t from '../../actions/friendProfileActionType';

const initialState = Map({
  loadingBadges: false,
  friendBadges: {
    wonBadges: 1,
    maxBadges: 40,
    badges: [
      {
        id: 1,
        url: './Icebreaker-Badge.png',
        title: 'Title1',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incidicunt ut labore et dolore magenta.',
      },
    ],
  },
});

const reducer = function FriendBadgesReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_FRIEND_BADGES:
      return state.set('friendBadges', action.friendBadges);

    case t.SET_IS_LOADING_FRIEND_BADGES:
      return state.set('loadingFriendBadges', action.isLoadingBadges);

    default:
      return state;
  }
};

export default reducer;
